export default __webpack_public_path__ + "static/media/Ballroll_00207.7a82e35a.png";